import { CustomFormField } from "../../../../utilis/component/CustomFormElement";
import { ProblemsFormData } from "./fieldData";
import { useForm } from "react-hook-form";
import { FC, useContext, useEffect } from "react";
import { Button, CircularProgress } from "@mui/material";
import { contextType, ProblemsContext } from "../Problems";
import { useMutation } from "react-query";
import {
  getDiagnosisforProblems,
  getproblemsofDiagnosis,
  getSocialLifeCycleStatus,
  postProbelms,
} from "../../../services";
import { useParams } from "react-router-dom";
import { postProblem } from "../type";
import { clinicId, user } from "../../../../constants";
import moment from "moment";
import usePopup from "../../../../hooks/usePopup";
import { EmrContext } from "../../..";

const ProblemsForm: FC<{ close?: () => void }> = ({ close }) => {
  const { control, reset, handleSubmit, watch } = useForm();
  const { encounterId, patientId } = useParams();
  const { showSnackbar } = usePopup();
  const { edit, setSuccess, success, setEdit, tableData } = useContext(
    ProblemsContext
  ) as contextType;
  const { triggerConsultationStart } = useContext(EmrContext);
  const { mutate: problemList, data: problemlistdata } = useMutation(
    getproblemsofDiagnosis
  );
  const { mutate: Diag, data: diagList } = useMutation(getDiagnosisforProblems);
  const { mutate: lifeCycleStatus, data: statusList } = useMutation(
    getSocialLifeCycleStatus
  );
  const { mutate: addProblem, isLoading } = useMutation(postProbelms, {
    onSuccess: (data) => {
      if (data.responseIndicator == "success") {
        data.response && setSuccess(!success), setEdit(null);
        showSnackbar({
          message: "Successfully added !",
          open: true,
          variant: "success",
          duration: 2000,
        });
        triggerConsultationStart();
      } else {
        showSnackbar({
          message: "Something went wrong !",
          open: true,
          variant: "warning",
          duration: 2000,
        });
      }
    },
  });
  useEffect(() => {
    if (encounterId) {
      Diag(encounterId);
      lifeCycleStatus();
    }
  }, []);
  const prepareProblem = (data: any): postProblem => {
    return {
      id: data.id || 0,
      problemId: data.icdSnomedDto.snomedId,
      diagnosisId: data.icdDto.diagId,
      lifeCycleStatusId: data.lifeCycleStatusDto.id,
      status: 1,
      createdById: Number(user?.userId),
      clinicId: clinicId,
      hl7MsgStatus: 0,
      isModified: 0,
      createdByDate: null,
      dateOfOnset: moment(data.dateOfOnset, "YYYY-MM-DD").format(
        "YYYY-MM-DD HH:mm:ss"
      ),
      resolvedDate: Boolean(data.resolvedDate)
        ? moment(data.resolvedDate, "YYYY-MM-DD").format("YYYY-MM-DD HH:mm:ss")
        : null,
      actionDate: null,
      notes: data.notes || "",
      encounterId: encounterId as string,
      patientId: patientId as string,
    };
  };

  const onsubmit = (data: any) => {
    if (tableData?.length > 0) {
      const duplicateEntry = tableData.find(
        (item) => item.icdDto.id == data.icdDto.icdId
      );
      if (duplicateEntry) {
        showSnackbar({
          message: "Already added !",
          open: true,
          variant: "warning",
          duration: 2000,
        });
      } else {
        const problemsData = prepareProblem(data);
        addProblem(problemsData);
        reset();
      }
    } else {
      const problemsData = prepareProblem(data);
      addProblem(problemsData);
      reset();
    }
  };

  useEffect(() => {
    reset({
      ...edit,
    });
    console.log(edit);

    problemList(watch("icdDto")?.icdCode);
  }, [edit]);

  return (
    <div>
      <form onSubmit={handleSubmit(onsubmit)}>
        <div className="grid grid-cols-12 gap-2 m-2">
          <div className="col-span-2">
            <CustomFormField
              control={control}
              {...ProblemsFormData.icdDto}
              options={diagList?.response || []}
              rules={{
                ...ProblemsFormData.icdDto.rules,
                onChange: (data) => problemList(data.target.value.icdCode),
              }}
            />
          </div>
          <div className="col-span-4">
            <CustomFormField
              control={control}
              options={problemlistdata?.response || []}
              {...ProblemsFormData.icdSnomedDto}
            />
          </div>
          <div className="col-span-2">
            <CustomFormField
              control={control}
              {...ProblemsFormData.lifeCycleStatusDto}
              options={statusList?.response || []}
            />
          </div>
          <div className="col-span-2">
            <CustomFormField
              control={control}
              {...ProblemsFormData.Dateofonset}
            />
          </div>
          <div className="col-span-2">
            <CustomFormField
              control={control}
              {...ProblemsFormData.resolvedDate}
            />
          </div>
          <div className="col-span-2">
            <CustomFormField control={control} {...ProblemsFormData.notes} />
          </div>
          <div className="col-span-10 flex justify-end items-center gap-3">
            <Button
              type="submit"
              color="success"
              disabled={isLoading}
              endIcon={isLoading && <CircularProgress size={18} />}
            >
              Save
            </Button>
            <Button
              color="error"
              onClick={() => {
                close && close();
              }}
            >
              cancel
            </Button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default ProblemsForm;
